var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ 'loading-new-image': _vm.loadingNewImage },attrs:{"src":_vm.src},on:{"load":_vm.onload}})}
var staticRenderFns = []

export { render, staticRenderFns }